import { UrlHelper, getToken } from '@ibiz-template/core';
import {
  isWeChat,
  isDingDing,
  IFrontExportParams,
  IBackendExportParams,
  IMobPlatformProvider,
  PlatformProviderBase,
} from '@ibiz-template/runtime';
import { DownloadType } from '.';

/**
 * @description 移动端搭载平台处理器基类
 * @export
 * @class MobPlatformProviderBase
 */
export abstract class MobPlatformProviderBase
  extends PlatformProviderBase
  implements IMobPlatformProvider
{
  /**
   * @description 下载
   * @param {string} url 下载路径
   * @param {string} name
   * @returns {*}  {Promise<boolean>}
   * @memberof MobPlatformProviderBase
   */
  async download(url: string, fileName: string): Promise<boolean> {
    // 钉钉和企业微信不支持直接下载，需跳转到默认浏览器中下载
    if (isWeChat() || isDingDing()) {
      const search = new URLSearchParams({
        type: DownloadType.DOWNLOAD,
        token: getToken() || '',
        data: JSON.stringify({ url, fileName }),
      });
      window.open(`${UrlHelper.routeBase}/download?${search}`, '_self');
      return Promise.resolve(true);
    }
    return super.download(url, fileName);
  }

  /**
   * @description 后台导出
   * @param {IBackendExportParams} args
   * @returns {*}  {Promise<boolean>}
   * @memberof MobPlatformProviderBase
   */
  async backendExport(args: IBackendExportParams): Promise<boolean> {
    if (isWeChat() || isDingDing()) {
      const search = new URLSearchParams({
        type: DownloadType.BACKEND_EXPORT,
        token: getToken() || '',
        data: JSON.stringify(args),
      });
      window.open(`${UrlHelper.routeBase}/download?${search}`, '_self');
      return Promise.resolve(true);
    }
    return super.backendExport(args);
  }

  /**
   * @description 前台导出
   * @param {IFrontExportParams} args
   * @returns {*}  {Promise<boolean>}
   * @memberof MobPlatformProviderBase
   */
  async frontExport(args: IFrontExportParams): Promise<boolean> {
    if (isWeChat() || isDingDing()) {
      const search = new URLSearchParams({
        type: DownloadType.FRONT_EXPORT,
        token: getToken() || '',
        data: JSON.stringify(args),
      });
      window.open(`${UrlHelper.routeBase}/download?${search}`, '_self');
      return Promise.resolve(true);
    }
    return super.frontExport(args);
  }

  getShowViewHeader(): boolean {
    return ibiz.config.view.mobShowViewHeader;
  }

  getShowPresetBack(): boolean {
    return ibiz.config.view.mobShowPresetBack;
  }
}
